export default __webpack_public_path__ + "static/media/right-side50.70ed5a26.png";